import { PLAY_STORE, SIGNATORY } from "@src/helpers/image_constants";
import React, { useEffect, useState } from "react";
const FooterSecondColumn = React.lazy(() => import("../footer_second_column"));

const FooterMobileViewSecondColumn = () => {
  const [is_in_app, set_is_in_app] = useState(false);

  const handle_redirect = () => {
    window.open("https://ifcncodeofprinciples.poynter.org/profile/youturn");
  };
  const handle_click_to_download = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.youturn&pli=1"
    );
  };
  useEffect(() => {
    // Detect if the app is in a WebView
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isWebView =
      /FBAN|FBAV|Instagram|Twitter|WebView|wv/.test(userAgent) ||
      !!window.ReactNativeWebView;

    set_is_in_app(isWebView);
  }, []);
  return (
    <div className="footer_mobile_second_column_container">
      <div className="quick_access_mobile_container">
        <FooterSecondColumn />
      </div>

      <div className="footer_first_column_signatory_image_container">
        {!is_in_app && (
          <img
            style={{ width: "130px", cursor: "pointer" }}
            src={PLAY_STORE}
            alt="play-store-download"
            onClick={handle_click_to_download}
          />
        )}
        <img
          onClick={handle_redirect}
          alt={"signatory"}
          src={SIGNATORY}
          className="footer_first_column_signatory_image"
        />
      </div>
    </div>
  );
};

export default FooterMobileViewSecondColumn;
